// @flow
import * as React from 'react';
// TODO: Uncoment actions error
// import { sendError } from './error.actions.js';

type Props = {
  children: React.Node
};

type State = {
  hasError: boolean
};

class ErrorHandler extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, info: string) {
    // Display fallback UI
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    console.log('error =>', error);
    console.log('info =>', info);
    // sendError(error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <h1 className="text-center">
          Oops...
          <br />
          <br />
          Something went wrong.
          <br />
          Please contact support.
          {/*The message about this unexpected situation has already been sent to the developers.*/}
        </h1>
      );
    }
    return this.props.children;
  }
}

export default ErrorHandler;
